import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

export const BulkActionMenuButton = styled(Button)<{ opened: number }>`
  background-color: ${({ opened }) => (opened ? '#d7dbdd' : 'transparent')} !important;
`;
